const Permission = () => {
    return (
        <>
            <h1>Permission</h1>
        </>
    );
};

export default Permission;